interface MicrosoftIconProps {
  className?: string
}

export const MicrosoftIcon: React.FC<MicrosoftIconProps> = ({
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 23 23"
    fill="none"
    role="img"
    aria-label="Microsoft logo"
    className={className}
  >
    <path fill="#F25022" d="M0 0h11v11H0z" />
    <path fill="#00A4EF" d="M0 12h11v11H0z" />
    <path fill="#7FBA00" d="M12 0h11v11H12z" />
    <path fill="#FFB900" d="M12 12h11v11H12z" />
  </svg>
)
